import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete, getLoginRoleIsSuper } from '@/api/PMS/customerService/returnVisit';
import { fetchList as fetchCustomerList } from '@/api/PMS/baseInformation/customer';
import { fetchRoleDeptUser, fetchToushu } from '@/api/system/role/role';
import waves from '@/directive/waves'; // 水波纹指令

import complaintReturnVisit from './returnVisit';
import complaintDetail from './detail'; // import complaintReturnVisit from '../complaintQuery/returnVisit'

export default {
  name: 'ComplexTable',
  components: {
    complaintReturnVisit: complaintReturnVisit,
    complaintDetail: complaintDetail
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      isDetail: false,
      listLoading: true,
      dialogDetailFormVisible: false,
      listQuery: {
        page: 1,
        limit: 10,
        posName: ''
      },
      complaintOption: [{
        name: '微信',
        value: 1
      }, {
        name: '电话',
        value: 2
      }, {
        name: '现场登记',
        value: 3
      }],
      statusOption: [{
        name: '未处理',
        value: 1
      }, {
        name: '处理中',
        value: 2
      }, {
        name: '已处理',
        value: 3
      }],
      satisfiedOption: [{
        name: '非常满意',
        value: 1
      }, {
        name: '满意',
        value: 2
      }, {
        name: '不满意',
        value: 3
      }, {
        name: '非常不满意',
        value: 4
      }],
      title: '',
      flowNum: '',
      complaintId: -1,
      customerOption: [],
      multipleSelection: [],
      dialogFormVisible: false,
      dialogFormReturnVisible: false,
      isSuper: '',
      userId: ''
    };
  },
  created: function created() {
    if (location.hash === '#/complaintManage/returnVisitQuery') {
      this.listQuery.sysType = 2;
    } else {
      this.listQuery.sysType = 1;
    }

    this.getList();
    this.getCustomerOption();
  },
  mounted: function mounted() {
    // this.isSuper = this.$store.getters.isSuper
    this.userId = this.$store.getters.roleId;
    console.log(this.$store.getters.roleId, 'vuex', this.$store.getters);
    this.getRole();
  },
  methods: {
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
      this.dialogFormReturnVisible = false;
      this.dialogDetailFormVisible = false;
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    getRole: function getRole() {
      var _this2 = this;

      getLoginRoleIsSuper({
        userId: this.userId
      }).then(function (response) {
        // this.list = response.data.data
        console.log(response.data.data); // this.isSuper = 0

        _this2.isSuper = response.data.data;
      });
    },
    getFlowDetail: function getFlowDetail(id, flowNum) {
      this.complaintId = id;
      this.flowNum = flowNum;
      this.dialogDetailFormVisible = true;
      this.title = '回访详情';
    },
    getCustomerOption: function getCustomerOption() {
      var _this3 = this;

      // fetchCustomerList({ customerType: 1 }).then(res => {
      //   this.customerOption = res.data.data
      // })
      fetchToushu({
        deptId: 0,
        userStatus: 0
      }).then(function (res) {
        _this3.customerOption = res.data.data;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 编辑
    handleUpdate: function handleUpdate(complaintId, flowNum) {
      this.complaintId = complaintId;
      this.flowNum = flowNum;
      this.title = '编辑';
      this.isDetail = false;
      this.dialogFormReturnVisible = true;
    },
    handleCheck: function handleCheck(complaintId, flowNum) {
      this.complaintId = complaintId;
      this.flowNum = flowNum;
      this.title = '回访详情';
      this.isDetail = true;
      this.dialogFormReturnVisible = true;
    },
    delete: function _delete(complaintIds) {
      var _this4 = this;

      if (complaintIds.length > 0) {
        this.$confirm('你确定是要删除这些记录, 是否继续?', '提示').then(function () {
          fetchDelete(complaintIds).then(function (response) {
            _this4.getList();

            _this4.Alert({
              alertType: 'delete'
            });
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(complaintId) {
      var complaintIds = [];
      complaintIds.push(complaintId);
      this.delete(complaintIds);
    },
    handleDeletes: function handleDeletes() {
      var complaintIds = [];
      this.multipleSelection.forEach(function (row) {
        complaintIds.push(row.complaintId);
      });
      this.delete(complaintIds);
    },
    isHideButton: function isHideButton(isSuper) {
      if (this.isSuper == null) {
        return false;
      } else {
        if (this.isSuper == 0) {
          return false;
        } else {
          return true;
        }
      }
    },
    selected: function selected(row, index) {
      console.log(row, 'row');

      if (this.isSuper == 1) {
        // 根据你的条件来设置
        return true; //可选择
      } else {
        return false; //不可选择
      }
    }
  }
};